/**
 * Release do Sentry — por que isto não pode ser uma constante.
 *
 * `release` é o campo que liga um erro ao código que o causou. Com um literal
 * fixo (`govio-core@0.1.0`), erros de todos os deploys caem no mesmo balde: o
 * Sentry não consegue dizer "isso apareceu no deploy de terça", não marca
 * regressão como resolvida-em-release e não separa um bug antigo de um recém
 * introduzido. O campo existe e não informa nada.
 *
 * A Vercel já publica o SHA do commit de cada deploy. Server e Edge leem
 * `VERCEL_GIT_COMMIT_SHA`. O browser precisa da variante `NEXT_PUBLIC_`, que só
 * entra no bundle se o acesso for **literal** — o Next inlina a expressão
 * `process.env.NEXT_PUBLIC_X` no build; nome montado por concatenação ou lido
 * via índice vira `undefined` no cliente. Por isso as duas leituras estão
 * escritas por extenso aqui, e cada ambiente tem a sua função.
 *
 * `SENTRY_RELEASE` continua vencendo quando definido, para o caso de o release
 * passar a ser criado por um passo de CI com sourcemaps.
 */

/** Vercel entrega string vazia em algumas envs ausentes; `??` não pegaria. */
function primeiroNaoVazio(
  ...valores: (string | undefined)[]
): string | undefined {
  for (const v of valores) {
    if (typeof v === "string" && v.trim().length > 0) return v.trim();
  }
  return undefined;
}

/** Usado quando não há SHA nenhum (dev local, teste). */
export const RELEASE_FALLBACK = "govio-core@dev";

export function resolveRelease(
  explicito: string | undefined,
  sha: string | undefined,
): string {
  return primeiroNaoVazio(explicito, sha) ?? RELEASE_FALLBACK;
}

/** Release para os runtimes Node e Edge. */
export function serverSentryRelease(): string {
  return resolveRelease(
    process.env.SENTRY_RELEASE,
    process.env.VERCEL_GIT_COMMIT_SHA,
  );
}

/** Release para o bundle do browser. */
export function clientSentryRelease(): string {
  return resolveRelease(
    process.env.NEXT_PUBLIC_SENTRY_RELEASE,
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  );
}
